import { Action, PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ToolkitStore } from '@reduxjs/toolkit/dist/configureStore';
import { AppStore } from '../types';
import { systemConfigRequest } from './sysConfigReducer';
import { routeNavRequest } from './routeNavReducer';
import { goodsCatRequest } from './goodsCatReducer';
import { protocolRequest } from './protocolReducer';

const startUpSlice = createSlice({
  name: 'startUp',
  initialState: 'noRequest',
  reducers: {
    startUp: (state: string, action: PayloadAction<string>) => {
      state = action.payload;
      return state;
    },
  },
});

export const { startUp } = startUpSlice.actions;
export default startUpSlice.reducer;

export const startUpEffect = {
  'startUp/startUp': async (store: ToolkitStore<AppStore>, action: Action) => {
    store.dispatch(systemConfigRequest());
    store.dispatch(routeNavRequest());
    store.dispatch(goodsCatRequest());
    store.dispatch(protocolRequest());
  },
};
